import React from 'react'
import PropTypes from 'prop-types'
import QuickLinks from 'components/shared/QuickLinks'
import { Row, Col } from 'antd'

export default function RelatedCategories({ relatedCategories }) {
  if (!relatedCategories) return null
  let title = ''
  const linkList = []
  title = 'Related Categories'
  relatedCategories.forEach((category) => {
    const { slug, name } = category
    linkList.push({
      href: '/faqs/[slug]',
      as: `/faqs/${slug}`,
      linkText: ` ${name} `,
    })
  })

  return (
    <Row style={{ marginBottom: '16px' }}>
      <Col span={24}>
        <QuickLinks title={title} linkList={linkList} />
      </Col>
    </Row>
  )
}

RelatedCategories.propTypes = {
  relatedCategories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ).isRequired,
}
